import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { getListGroupByNameDockerImageQuery } from '../apis';
import { setFieldDockerImage } from '..';
import { deepClone } from '@tenant/utility/helper/Utils';
import { useDispatch } from 'react-redux';

const useGetListGroupByNameDockerImage = () => {
  const dispatch = useDispatch();

  const getData = useQuery({
    queryKey: ['docker-group-by-image-list'],
    queryFn: getListGroupByNameDockerImageQuery,
    onSuccess: (data) => {
      dispatch(setFieldDockerImage({ field: 'list', value: deepClone(data) }));
    },
  });

  return getData;
};

export default useGetListGroupByNameDockerImage;
